var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnalyze(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2169 5.6666L14.8752 4.20827L16.3335 3.54993C16.6585 3.39993 16.6585 2.9416 16.3335 2.7916L14.8752 2.13327L14.2169 0.666602C14.0669 0.341602 13.6085 0.341602 13.4585 0.666602L12.8002 2.12493L11.3335 2.78327C11.0085 2.93327 11.0085 3.3916 11.3335 3.5416L12.7919 4.19993L13.4502 5.6666C13.6002 5.9916 14.0669 5.9916 14.2169 5.6666ZM7.58353 6.9166L6.25853 3.99993C5.96686 3.34993 5.03353 3.34993 4.74186 3.99993L3.41686 6.9166L0.500195 8.2416C-0.149805 8.5416 -0.149805 9.4666 0.500195 9.75827L3.41686 11.0833L4.74186 13.9999C5.04186 14.6499 5.96686 14.6499 6.25853 13.9999L7.58353 11.0833L10.5002 9.75827C11.1502 9.45827 11.1502 8.53327 10.5002 8.2416L7.58353 6.9166ZM13.4502 12.3333L12.7919 13.7916L11.3335 14.4499C11.0085 14.5999 11.0085 15.0583 11.3335 15.2083L12.7919 15.8666L13.4502 17.3333C13.6002 17.6583 14.0585 17.6583 14.2085 17.3333L14.8669 15.8749L16.3335 15.2166C16.6585 15.0666 16.6585 14.6083 16.3335 14.4583L14.8752 13.7999L14.2169 12.3333C14.0669 12.0083 13.6002 12.0083 13.4502 12.3333Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalyze);
export default __webpack_public_path__ + "static/media/Analyze.916ae8f23657422c7beaea160e5ae787.svg";
export { ForwardRef as ReactComponent };